export class DelinoCheckCustomerAddressModel {
  Lat: number;
  Lng: number;
  ShippingCost: number;
  CustomerId: number;
  BranchId: number;
  Address: string;
  CustomerName: string;
  PhoneNumber: string;
  isPickup: boolean;
}
